import React from "react";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import VideoOffFilled32 from "@carbon/icons-react/lib/video--off--filled/32";
import commonStyles from "../styles/Common.styles";

const EmptyStream = () => {
	const commonClasses = commonStyles();

	return (
		<Box
			alignItems="center"
			display="flex"
			flexDirection="column"
			justifyContent="center"
			className={commonClasses.container}
		>
			<VideoOffFilled32 className={commonClasses.contentCenteredIcon} />
			<Typography variant="h3">No Streams Available</Typography>
		</Box>
	);
};

export default EmptyStream;
